export const subunits = [
  {
    name: 'Adrian',
    settings: {
      center: { lng: -84.06048062509922, lat: 41.89518030305399 },
      zoom: 12.05,
    },
  },
  {
    name: 'Alpena',
    settings: {
      center: { lng: -83.44162314626504, lat: 45.06346891170821 },
      zoom: 11.583547427355004,
    },
  },
  {
    name: 'Detroit',
    settings: {
      center: { lng: -83.14076461962742, lat: 42.35650434829165 },
      zoom: 9.849394575307429,
    },
  },
  {
    name: 'Grand Rapids',
    settings: {
      center: { lng: -85.67299167903252, lat: 42.938829733547806 },
      zoom: 10.691723037338736,
    },
  },
  {
    name: 'Lansing',
    settings: {
      center: { lng: -84.53701074844264, lat: 42.693359086801536 },
      zoom: 11.046931327595447,
    },
  },
  {
    name: 'Marquette',
    settings: {
      center: { lng: -87.42195440373962, lat: 46.541789257104455 },
      zoom: 11.464117081039252,
    },
  },
];
